import type { ReactNode } from "react";
import { Card } from "../../components/ui";

/** Shared toolbar above each report for date controls. */
export function ReportControls({ children }: { children: ReactNode }) {
  return (
    <Card className="mb-4 flex flex-wrap items-end gap-4 p-4">{children}</Card>
  );
}

export function DateInput({
  label,
  value,
  onChange,
}: {
  label: string;
  value: string;
  onChange: (v: string) => void;
}) {
  return (
    <label className="block">
      <span className="label">{label}</span>
      <input
        type="date"
        className="input w-44"
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </label>
  );
}

export function ReportSectionTable({
  title,
  rows,
  total,
  currency,
}: {
  title: string;
  rows: { name: string; amount: number; code?: string | null }[];
  total: number;
  currency: string;
}) {
  return (
    <div className="mb-4">
      <h3 className="border-b border-gray-200 px-1 py-2 text-sm font-semibold uppercase tracking-wide text-gray-500">
        {title}
      </h3>
      <table className="min-w-full">
        <tbody>
          {rows.map((r, i) => (
            <tr key={i} className="border-b border-gray-50">
              <td className="px-1 py-1.5 text-sm text-gray-700">
                {r.code && <span className="mr-2 font-mono text-gray-400">{r.code}</span>}
                {r.name}
              </td>
              <td className="px-1 py-1.5 text-right text-sm tabular-nums text-gray-800">
                {new Intl.NumberFormat("en-US", {
                  style: "currency",
                  currency,
                }).format(r.amount / 100)}
              </td>
            </tr>
          ))}
          <tr className="font-semibold">
            <td className="px-1 py-2 text-sm">Total {title}</td>
            <td className="px-1 py-2 text-right text-sm tabular-nums">
              {new Intl.NumberFormat("en-US", {
                style: "currency",
                currency,
              }).format(total / 100)}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
